module.exports = __webpack_public_path__ + "static/media/about.5fc23cd2.jpg";